import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'bh-worry',
  templateUrl: './bh-worry.component.html',
  styleUrls: ['./bh-worry.component.scss']
})
export class BhWorryComponent implements OnInit {
  @Input() text: string;
  @Input('type') set _type(_type) {
    if (_type) {
      this.interface.type = _type;
    }
  }

  interface = {
    type: '',
    list: []
  }

  constructor() { }

  ngOnInit(): void {
  }

}
